import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

export default function WelcomeSection() {
  return (
    <section 
      className={cn(
        "relative min-h-[40vh] flex items-center justify-center text-center",
        "bg-cover bg-center bg-no-repeat"
      )}
      style={{
        backgroundImage: "url('/Rectangle 3842.jpg')",
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="absolute inset-0 bg-primary/60 z-[1]" />
      <Container>
        <Stack spacing="md" align="center" className="relative z-[2] max-w-3xl mx-auto py-20">
          <Heading level="h1" className="text-3xl md:text-4xl lg:text-5xl font-bold text-white drop-shadow-lg">
            Get in Touch with Us
          </Heading>
          <Text size="lg" className="text-white/90 max-w-2xl">
            Have questions or need assistance? Fill out the form or reach us
            through the contact details below. We're here to help!
          </Text>
        </Stack>
      </Container>
    </section>
  );
}
